import Vue from 'vue';
import route from "ziggy-js";
import { Ziggy } from './ziggy.js';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { ValidationProvider, ValidationObserver, setInteractionMode, extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/pt_BR.json';
import VueTheMask from 'vue-the-mask';
import PhoneNumber from 'awesome-phonenumber';
import {validateCnpj, validateCpf} from "@rules/docs";
import VueFormWizard from 'vue-form-wizard';
import DateRangePicker from 'vue2-daterange-picker';
import VueCurrencyFilter from 'vue-currency-filter';
import VueSweetalert2 from 'vue-sweetalert2';
import VueClipboard from 'vue-clipboard2';
import vueMoment from 'vue-moment';
import vueFilterPrettyBytes from 'vue-filter-pretty-bytes';
import VTWhatsapp from "@api/vt.whatsapp";
import _ from 'lodash';

library.add(far, fas, fab);
dom.watch();

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueTheMask);
Vue.use(VueFormWizard);
Vue.use(VueCurrencyFilter, {
    symbol : 'R$',
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true
});
Vue.use(VueClipboard);
Vue.use(vueFilterPrettyBytes);
Vue.use(VueSweetalert2);
Vue.use(vueMoment);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('date-range-picker', DateRangePicker);

Object.keys(rules).forEach(rule => {
    extend(rule, {
        ...rules[rule], // copies rule configuration
        message: messages[rule] // assign message
    });
});

extend('cpf', value => {
    if (validateCpf(value)) {
        return true;
    }
    return 'CPF Inválido';
});

extend('cnpj', value => {
    if (validateCnpj(value)) {
        return true;
    }
    return 'CNPJ Inválido';
});

extend('birthdate', value => {
    console.log(value);
    if (moment().diff(value, 'years') >= 16) {
        return true;
    }
    return 'Data de nascimento inválida.';
});

extend('phone', {
    message (fieldName) {
        return `Telefone inválido`;
    },
    validate (value) {
        return new Promise(resolve => {
            let phone = new PhoneNumber("+55" + value.replace(/[^0-9]/g, ''));
            resolve({ valid: phone.isValid() })
        });
    }
});

extend('whatsapp', {
    message (fieldName) {
        return `Whatsapp inválido`;
    },
    validate (value) {
        return new Promise(resolve => {
            let phone = new PhoneNumber("+55" + value.replace(/[^0-9]/g, ''));
            if (phone.isValid()) {
                VTWhatsapp.validar(value.replace(/[^0-9]/g, '')).then(function(dados) {
                    if (dados.status === 1) {
                        resolve({valid: true})
                    }
                    resolve({valid: false})
                });
            }
        });
    }
});

extend('password', {
    params: ['target'],
    validate(value, { target }) {
        return value === target;
    },
    message: 'A senha e a confirmação da senha devem ser iguais.'
});

const LoginForm = () => import(/* webpackChunkName: "autenticacao" */ '@components/auth/LoginForm.vue');
const RegisterForm = () => import(/* webpackChunkName: "autenticacao" */ '@components/auth/RegisterForm.vue');
const EmpresasEditarForm = () => import(/* webpackChunkName: "empresas" */ '@components/Empresas/EditarForm.vue');
const FiliaisAdicionarForm = () => import(/* webpackChunkName: "filiais" */ '@components/Filiais/AdicionarForm.vue');
const FiliaisEditarForm = () => import(/* webpackChunkName: "filiais" */ '@components/Filiais/EditarForm.vue');
const FuncionariosAdicionarForm = () => import(/* webpackChunkName: "funcionarios" */ '@components/Funcionarios/AdicionarForm.vue');
const FuncionariosEditarForm = () => import(/* webpackChunkName: "funcionarios" */ '@components/Funcionarios/EditarForm.vue');
const PedidosAdicionarForm = () => import(/* webpackChunkName: "pedidos" */ '@components/Pedidos/AdicionarForm.vue');
const SolicitantesAdicionarForm = () => import(/* webpackChunkName: "solicitantes" */ '@components/Solicitantes/AdicionarForm.vue');
const SolicitantesEditarForm = () => import(/* webpackChunkName: "solicitantes" */ '@components/Solicitantes/EditarForm.vue');
const ModalImportacao = () => import(/* webpackChunkName: "modalimportacao" */ '@components/Modais/ModalImportacao.vue');

Vue.component('login-form', LoginForm);
Vue.component('register-form', RegisterForm);
Vue.component('empresas-editar-form', EmpresasEditarForm);
Vue.component('filiais-adicionar-form', FiliaisAdicionarForm);
Vue.component('filiais-editar-form', FiliaisEditarForm);
Vue.component('funcionarios-adicionar-form', FuncionariosAdicionarForm);
Vue.component('funcionarios-editar-form', FuncionariosEditarForm);
Vue.component('pedidos-adicionar-form', PedidosAdicionarForm);
Vue.component('solicitantes-adicionar-form', SolicitantesAdicionarForm);
Vue.component('solicitantes-editar-form', SolicitantesEditarForm);
Vue.component('modal-importacao', ModalImportacao);

Vue.directive('uppercase', {
    bind (el, _, vnode) {
        el.addEventListener('input', (e) => {
            e.target.value = e.target.value.toUpperCase()
            vnode.componentInstance.$emit('input', e.target.value.toUpperCase());
        })
    }
});

Vue.mixin({
    data: () => ({
        alert: {
            type: "",
            show: false,
            message: ""
        },
        token: window.VTSolucoes.csrfToken,
    }),
    methods: {
        rota: (name, params, absolute) => route(name, params, absolute, Ziggy),
        showError(msg) {
            const vm = this;
            vm.alert.message = msg;
            vm.alert.type = "danger";
            vm.alert.show = true;
            window.scrollTo({top: 0, behavior: 'smooth'});
        },
        showSuccess(msg) {
            const vm = this;
            vm.alert.message = msg;
            vm.alert.type = "success";
            vm.alert.show = true;
            window.scrollTo({top: 0, behavior: 'smooth'});
        },
        showLoading: () => $("#overlay").show(),
        hideLoading: () => $("#overlay").hide(),
        showAlert: function(message, type = 'error') {
            return this.$swal({
                icon: type,
                text: message,
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false
            });
        },
        showAlertHtml: function(message, type = 'error') {
            return this.$swal({
                icon: type,
                html: message,
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false
            });
        },
        processErrors: function(message, errors) {
            if (errors && Object.keys(errors).length > 0) {
                for (let i in errors) {
                    for (let j in errors[i]) {
                        message += errors[i][j] + "<br />"
                    }
                }
            }
            return message;
        },
        copyObject(object) {
            return JSON.parse(JSON.stringify(object));
        },
        converteMoedaFloat(valor){
            console.log(valor);
            if(valor === ""){
                valor =  0;
                console.log("val", valor);
            }else{
                valor = valor.replace("R$","");
                valor = valor.replace(".","");
                valor = valor.replace(",",".");
                valor = valor.trim();
                valor = parseFloat(valor);
                console.log("val1", valor);
            }
            return valor;
        }
    },
});

Vue.filter('money', function (value) {
    let intl = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
    return intl.format(value)
});

Vue.config.productionTip = false;

window.Papa = require('papaparse');

window.app = new Vue({
    el: '#app',
});

$(document).ready(function (){
    window.app.hideLoading();
});
